export const urls = {
  controlledSubstanceGuidance: () => "/api/client/v1/controlled-substances/guidance/",
};

export const keys = {
  all: () => ["controlled-substances"],
  guidance: () => [...keys.all(), "guidance"],
};
